import { MenuType, PageTypeSuffix } from '@/constants'
import { type Menu } from '@/types'
import { getTranslate } from '@/utils/api-interceptors'
import { getCategoryLink } from '@/utils/next-util'
import Link from 'next/link'
import { useMemo } from 'react'
import 'react-loading-skeleton/dist/skeleton.css'
import type { Settings } from 'react-slick'
import ImageOptimize from '../ImageOptimize'
import Slider from '../Slider/Slider'

interface HomeQuickMenuProps {
  quickMenuData: Menu[]
}

const HomeQuickMenu = ({ quickMenuData }: HomeQuickMenuProps) => {
  const settingsOneRow: Settings = {
    dots: false,
    infinite: false,
    speed: 500,
    arrows: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    centerPadding: '10px',
    responsive: [
      {
        breakpoint: 1200,
        settings: { slidesToShow: 4 },
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: 3 },
      },
      {
        breakpoint: 576,
        settings: { slidesToShow: 2 },
      },
      {
        breakpoint: 480,
        settings: { slidesToShow: 1 },
      },
    ],
  }

  const renderedData = useMemo(() => {
    const result: (Menu | Menu[])[] = []

    ;(quickMenuData || []).forEach((item, i) => {
      const odd = i % 5
      switch (odd) {
        case 0:
          result.push(item)
          break
        case 1:
        case 3:
          result.push([item])
          break
        case 2:
        case 4:
          ;(result[result.length - 1] as Menu[]).push(item)
          break
        default:
          break
      }
    })

    return result.map((x, i) => ({ item: x, key: i }))
  }, [quickMenuData])

  return renderedData.length ? (
    <Slider {...settingsOneRow}>
      {renderedData.map(({ item, key }) => (
        <div key={key}>
          <div className='flex h-[240px] flex-col gap-3 px-2'>
            {Array.isArray(item) &&
              item.map(item1 => (
                <Link
                  key={item1._id}
                  href={
                    item1.type === MenuType.PRODUCT_CAT
                      ? `/${item1.slug + PageTypeSuffix.CATEGORY}`
                      : item1.url || '/'
                  }
                  className='flex max-h-[50%] grow gap-3 rounded-sm bg-white p-3'
                >
                  <span className='block w-1/2 grow text-lg font-semibold text-main'>
                    {getTranslate(item1.name)}
                  </span>
                  <ImageOptimize
                    src={item1.icon}
                    alt={getTranslate(item1.name)}
                    width={88}
                    height={88}
                    className='aspect-square h-[88px] object-contain'
                  />
                </Link>
              ))}

            {!Array.isArray(item) && (
              <div className='h-full rounded-sm bg-white p-3'>
                <Link
                  href={getCategoryLink(item)}
                  className='flex flex-col justify-between'
                >
                  <span className='grow text-lg font-semibold text-main'>
                    {getTranslate(item.name)}
                  </span>
                  <ImageOptimize
                    src={item.icon}
                    alt={getTranslate(item.name)}
                    width={175}
                    height={175}
                    className='mx-auto my-auto aspect-square w-[175px] object-contain'
                  />
                </Link>
              </div>
            )}
          </div>
        </div>
      ))}
    </Slider>
  ) : null
}
export default HomeQuickMenu
